import React from 'react';
import {Row, Col, Card} from 'react-materialize';

import background from '../../images/background.png';

const Home= () => (

 <div>

 </div>
    );

export default Home;